/* Copyright (c) 2021-2022 VMware, Inc. All rights reserved. -- VMware Confidential */
import { Injectable } from '@angular/core';
import { AppConfigService } from "src/app/services/app-config";

// @formatter:off
@Injectable({
    providedIn: "root"
})
// @formatter:on
export class LoggerService {

    constructor(private appConfig: AppConfigService) {}

    /**
     * Log developer messages if this is a non-production build.
     * @param args - any arguments accepted by the console.log function
     */
    debug(...args: any[]): void {
        if (this.appConfig.production) {
            return;
        }

        console.log("[LoggerService.debug]", ...args);
    }
}
